import { colors, type ThemeProps } from '../../style';

export const variants = {
  emerald: () => ({
    background: colors.emerald,
  }),
  'negative-dark': () => ({
    background: colors.negativeDark,
  }),
  negative: () => ({
    background: colors.negative,
  }),
  pumpkin: () => ({
    background: colors.pumpkin,
  }),
  sun: () => ({
    background: colors.sun,
  }),
  highlight: () => ({
    background: colors.highlight,
  }),
  coral: () => ({
    background: colors.coral,
  }),
  action: ({ theme }: { theme: ThemeProps }) => ({
    background: theme.actionColor,
  }),
  positive: () => ({
    background: colors.positive,
  }),
  teal: () => ({
    background: colors.teal,
  }),
};

export const sizes = {
  xs: {
    height: 4,
    borderRadius: 4,
  },
  sm: {
    height: 8,
    borderRadius: 4,
  },
  lg: {
    height: 16,
    borderRadius: 8,
  },
};
